import { render, staticRenderFns } from "./HeaderInformationNavigationEdunetin.vue?vue&type=template&id=200cd080&scoped=true"
import script from "./HeaderInformationNavigationEdunetin.vue?vue&type=script&lang=ts"
export * from "./HeaderInformationNavigationEdunetin.vue?vue&type=script&lang=ts"
import style0 from "./HeaderInformationNavigationEdunetin.vue?vue&type=style&index=0&id=200cd080&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200cd080",
  null
  
)

export default component.exports